export const nullable = (compare) => (left, right) => {
    if (left != null && right != null) {
        return compare(left, right);
    }
    if (left === right) {
        return 0;
    }
    return left == null ? -1 : 1;
};
export * from 'effect/Order';
//# sourceMappingURL=Order.js.map